import { Modal } from 'antd';
import {
  AddUserModalProps,
  ButtonLabels,
  FieldLabels,
} from 'enums/AddUserModalProps';
import React from 'react';
import styles from './AddUserModal.module.scss';
import { Form, Formik } from 'formik';
import { validationSchema } from './AddUserModalConstants';
import InputField from '../InputField';
import COSelect from '../COSelect';
import COButton from '../COButton';
import { User } from 'models/User/User.model';
import { Role } from 'models/Role/role.model';
import { modalCloseIcon } from '../OrganizationModal';
import { UserAccount } from 'services/AccountsService/accounts.service';

interface AddUserModal {
  showModalState: boolean;
  handleModalCancel: (payload: boolean) => void;
  handleModalConfirm: (payload: boolean) => void;
  headingEdit?: string;
  preFetchedData?: User;
  createUserAccount?: (User: UserAccount) => Promise<void>;
  updateUserAccount?: (id: number | undefined, User: UserAccount) => void;
  roleList: Role[];
}

const AddUserModal: React.FC<AddUserModal> = ({
  showModalState,
  handleModalCancel,
  handleModalConfirm,
  preFetchedData,
  createUserAccount,
  updateUserAccount,
  roleList,
}: AddUserModal) => {
  const handleCloseModal = () => {
    handleModalConfirm(false);
  };
  const handleCancelModal = () => {
    handleModalCancel(false);
  };
  const preFetchedValue:UserAccount = {
    name: preFetchedData ? preFetchedData.name : '',
    role: preFetchedData ? preFetchedData.userRole?.id : undefined,
    email: preFetchedData ? preFetchedData.email : '',
    phone: preFetchedData ? preFetchedData.phone : '',
    position: preFetchedData ? preFetchedData.position : '',
    association: preFetchedData?.association ?? '',
    extension: '+1',
  };
  const handleFormSubmission = async (values: UserAccount) => {
    try {
      if (preFetchedData) {
        updateUserAccount &&
          (await updateUserAccount(preFetchedData.id, {
            ...values,
          }));
      } else {
        createUserAccount &&
          (await createUserAccount({
            ...values,
          }));
      }

      handleCloseModal();
    } catch (error) {}
  };

  return (
    <>
      <Modal
        destroyOnClose={true}
        width={AddUserModalProps.MODAL_WIDTH}
        footer={null}
        wrapClassName={styles.modalContainer}
        open={showModalState}
        closeIcon={modalCloseIcon}
        onCancel={handleCancelModal}>
        <div className={styles.formContainer}>
          <div className={styles.headerContainer}>
            <h2>
              {preFetchedData
                ? AddUserModalProps.MODAL_HEADING_EDIT
                : AddUserModalProps.MODAL_HEADING_CREATE}
            </h2>
          </div>
          <Formik
            enableReinitialize
            initialValues={preFetchedValue}
            validationSchema={validationSchema}
            onSubmit={handleFormSubmission}>
            {({ isSubmitting }) => (
              <Form>
                <div className={styles.fieldContainer}>
                  <InputField
                    name={FieldLabels.USER_NAME}
                    placeholderstring={FieldLabels.USER_NAME_PLACEHOLDER}
                    label={FieldLabels.USER_NAME_LABEL}
                  />
                </div>
                <div className={styles.fieldContainer}>
                  <COSelect
                    name={FieldLabels.ROLE}
                    placeholderstring={FieldLabels.ROLE_PLACEHOLDER}
                    label={FieldLabels.ROLE_LABEL}
                    options={roleList}
                  />
                </div>
                <div className={styles.fieldContainer}>
                  <InputField
                    name={FieldLabels.EMAIL}
                    placeholderstring={FieldLabels.EMAIL_PLACEHOLDER}
                    label={FieldLabels.EMAIL_LABEL}
                    disabled={preFetchedData !== undefined}
                  />
                </div>
                <div className={styles.fieldContainer}>
                  <InputField
                    name={FieldLabels.PHONE_NUMBER}
                    placeholderstring={FieldLabels.PHONE_NUMBER_PLACEHOLER}
                    label={FieldLabels.PHONE_NUMBER_LABEL}
                    addonbefore={FieldLabels.addonbefore}
                  />
                </div>
                <div className={styles.fieldContainer}>
                  <InputField
                    name={FieldLabels.POSITION}
                    placeholderstring={FieldLabels.POSITION_PLACEHOLER}
                    label={FieldLabels.POSITION_LABEL}
                  />
                </div>
                <div className={styles.fieldContainer}>
                  <InputField
                    name={FieldLabels.ASSOCIATE_BRAND}
                    placeholderstring={FieldLabels.ASSOCIATE_BRAND_PLACEHOLDER}
                    label={FieldLabels.ASSOCIATE_BRAND_LABEL}
                  />
                </div>
                <div className={styles.buttonContainer}>
                  <COButton submit loading={isSubmitting}>
                    {preFetchedData ? ButtonLabels.EDIT : ButtonLabels.CONFIRM}
                  </COButton>
                  <COButton secondary onClick={handleCancelModal}>
                    {ButtonLabels.CANCEL}
                  </COButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};

export default AddUserModal;
